/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Narendra Prabhu",
  title: "Hi all, I'm Narendra",
  subTitle: emoji(
    "A passionate Software Developer with strong experience building AI/ML, backend, cloud-native applications with Python / Go / Terraform some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1HYA5y7qr08d9Mprr3_XYARTG5BAezH7w/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/narphu",
  linkedin: "https://www.linkedin.com/in/naren-prabhu",
  gmail: "narenprabhu17@gmail.com",
  medium: "https://medium.com/@narenprabhu",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  display: true,
  title: "What I Do",
  subTitle: "Designing, Scaling, and Shipping Production AI/ML and Cloud-native Systems",
  skills: [
    "⚙️ Backend engineering with Python, Go, and Kubernetes",
    "📦 ML model training, evaluation and deployment with SageMaker, MLflow, Keras, Tensorflow, scikit-learn, prophet and TorchServe",
    "🚀 Infrastructure automation with Terraform, Docker, and GitHub Actions",
    "📊 Cloud-native observability using Datadog, ELK and Prometheus"
  ],
  softwareSkills: [
    { skillName: "Python", fontAwesomeClassname: "fab fa-python" },
    { skillName: "Go", fontAwesomeClassname: "fab fa-golang" },
    { skillName: "FastAPI", fontAwesomeClassname: "fab fa-fastapi" },
    { skillName: "Kubernetes", fontAwesomeClassname: "logos:kubernetes" },
    { skillName: "AWS", fontAwesomeClassname:  "fab fa-aws" },
    { skillName: "Terraform", fontAwesomeClassname: "logos:terraform" },
    { skillName: "Docker", fontAwesomeClassname: "fab fa-docker" },
    { skillName: "MLflow", fontAwesomeClassname: "simple-icons:mlflow" },
    { skillName: "React", fontAwesomeClassname: "fab fa-react" },
  ],
};

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Massachusetts Amherst",
      logo: require("./assets/images/umasslogo.png"),
      subHeader: "Master of Science in Computer Engineering",
      duration: "September 2018 - September 2020",
      desc: "Participated in the research of docker-based emulators and published 3 papers.",
      descBullets: [
        "Computer Architecture",
        "Operating Systems",
        "Green Computing",
        "Data analytics and IOT"
      ]
    },
    {
      schoolName: "National Institute of Technology Goa",
      logo: require("./assets/images/nitgoalogo.png"),
      subHeader: "Bachelor of Technology in Electronics and Communication Engineering",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 1% in the program. Capstone project to enable IOT-based smart metering systems for rural locations",
      descBullets: ["Software Engineering", "Information Theory","Web Security", "Database Systems"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Cloud Native (Kubernetes, AWS)", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend (Gin, FastAPI, Flask)",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming (Python, GoLang)",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  title: "Experience",
  subtitle: "What I've Done",
  experience: [
    {
      role: "Member of Technical Staff",
      company: "Magic",
      description:
        "Supercomputing and HPC engineer building and operating large-scale GPU supercomputers for frontier AI training.",
      date: "2026 - Present",
      companylogo: require("./assets/images/magiclogo.png")
    },
    {
      role: "Senior Software Engineer",
      company: "Marqeta",
      description:
        "Built secure, scalable backend systems and infrastructure automation. Led Kubernetes and observability integrations for core services.",
      date: "2024 - 2026",
      companylogo: require("./assets/images/marqetalogo.png")
    },
    {
      role: "Senior Software Engineer (tech lead)",
      company: "Vertica",
      description:
        "Developed 0 to 1 a DBaaS using Go, Terraform, EKS, and cloud-native monitoring strategies.",
      date: "2021 - 2024",
      companylogo: require("./assets/images/verticalogo.png")
    },
    {
      role: "Software Engineer",
      company: "Dell Technologies",
      description:
        "Worked on developing cloud-native systems and firmware related development for Dell's Infrastructure group",
      date: "2020 - 2021",
      companylogo: require("./assets/images/delllogo.jpg")
    }
  ],
  display: true,
};


/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "Some projects I have worked on",
  projects: [
  {
    projectName: "Stock Analyzer",
    projectDesc: "End‑to‑end ML system predicting stock trends via FastAPI, React, deployed on AWS ECS & SageMaker.",
    footerLink: [{
      name: "Visit Website",
      url: "https://stock-analyzer.shrubb.ai",
      github: "https://github.com/narphu/stock-analyzer"
    }],
    
  },
  {
    projectName: "Supply Chain Optimization",
    projectDesc: "An RL agent that learns to manage inventory and restocking across warehouses, minimizing costs (storage, shipping, out-of-stock) and handling uncertainty in demand and delivery. — ETL, feature engineering, ML model hosted on AWS.",
    footerLink: [{
      name: "Check Github",
      url: "https://github.com/narphu/supply-chain-rl",
      github: "https://github.com/narphu/supply-chain-rl"
    }],
  },
  {
    projectName: "MLOps Pipeline for Churn Prediction",
    projectDesc: "A robust, production-ready MLOps pipeline for customer churn prediction.",
    footerLink: [{
      name: "Visit Website",
      url: "https://github.com/narphu/churn/tree/master",
      github: "https://github.com/narphu/churn/tree/master"
    }],
  },
  {
    projectName: "MANET Emulator",
    projectDesc: "Nested Docker-based emulator that simulates a mobile ad-hoc network such as satellite movement",
    footerLink: [{
      name: "Visit Website",
      url: "https://ieeexplore.ieee.org/document/9244858"
    }],
  },
],
display: true
}


// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Publications 🏆 "),
  subtitle:
    "Achievements, Publications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [

    {
      title: "MANET Emulator",
      subtitle: "Published thesis on MANET emulators using Dockerized nodes and OpenVSwitch network",
      footerLink: [
        {
          name: "Publication",
          url: "https://ieeexplore.ieee.org/document/9244858"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1-3392134127",
  email_address: "narenprabhu17@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
